import React, { useState, useEffect, useRef } from 'react';
import {
  getMachineRequest,
  getQuotationListRequest,
  deleteQuotation,
  editQuotation,
  createQuotation,
} from '../../services/mm/apiController';
import { useSelector } from 'react-redux';
import { factoryId, loggedInUser } from '../../store/reducers/account_reducer';
import { Link, useParams } from 'react-router-dom';
import { formatDate } from '../../util/helper';
import { DeleteIcon, DownloadIcon, EditIcon, ViewIcon } from '../vm/components/icons';
import { toast, ToastContainer } from 'react-toastify';
import { destroy } from '../../services/apiController';
import { TABLE_DEFAULT_LIMIT } from '../../util/constant';
import { Table, Modal, Button, Form, FloatingLabel, Row, Col, Alert } from 'react-bootstrap';
import 'react-toastify/dist/ReactToastify.css';
import AlertIcon from '../../img.svg';
import PaginationInPage from '../Pagination';
import axios from 'axios';
import { getStoredData, get_auth_key } from '../../util';

const MachineRequestDetails = (props) => {
  const factoryId_ = useSelector(factoryId);
  const formFields = {
    vendorName: '',
    price: '',
    description: '',
    gst: '',
    contactNumber: '',
    email: '',
    contactPerson: '',
    address: '',
    requestUUID: '',
    file1: null,
    file_1: '',
    file2: null,
    file_2: '',
    factoryId: factoryId_,
    createdBy: '02a08619-56a5-4c94-9728-94f4e4d2a1c8',
  };

  const storedData = JSON.parse(getStoredData(get_auth_key()));
  const [requestDetail, setRequestDetail] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [quotationList, setQuotationList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(1);
  const [quotationForm, setQuotationForm] = useState(formFields);
  let params = useParams();
  const [show, setShow] = useState(false);
  const [validated, setValidated] = useState(false);
  const [vendorName, setVendorName] = useState('');
  const [documentShowConfirmModel, setDocumentShowConfirmModel] = useState(false);
  const handleCloseDocumentConfirmModal = () => {
    setDocumentShowConfirmModel(false);
  };
  const [fieldToDeleted, setFieldToDeleted] = useState('');
  const [showConfirmModel, setShowConfirmModel] = useState(false);
  const handleCloseConfirmModal = () => {
    setShowConfirmModel(false);
  };
  const [quotationIdToDeleted, setQuotationIdToDeleted] = useState('');
  const [machineToDeleted, setMachineToDeleted] = useState('');
  const clickToDownload = useRef(null);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const handleShow = () => {
    setShow(true);
    setValidated(false);
    setQuotationForm(formFields);
  };
  const handleClose = () => setShow(false);

  const handleShowDocumentConfirmModal = (e, field) => {
    e.preventDefault();
    setDocumentShowConfirmModel(true);
    setFieldToDeleted(field);
  };

  const handleShowConfirmModal = (e, quotationId, machineRequestId) => {
    e.preventDefault();
    setShowConfirmModel(true);
    setQuotationIdToDeleted(quotationId);
    setMachineToDeleted(machineRequestId);
  };

  const handleChange = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setQuotationForm({ ...quotationForm, [name]: value });
  };

  const onChangeDocumentOne = (e) => {
    e.preventDefault();
    if (e.target.files[0] && e.target.files[0].name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      setQuotationForm({ ...quotationForm, file1: null, file_1: '' });
      toast.error('Please select a valid file type.');
    } else {
      const file = e.target.files[0] || null;

      const formData = new FormData();
      formData.append('fileName', file);

      axios
        .post(process.env.REACT_APP_BASE_URL + '/mm/file', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'x-access-token': storedData.token,
          },
        })
        .then((resp) => {
          if (resp.status === 200) {
            setQuotationForm({ ...quotationForm, file_1: resp.data });
          } else {
            toast.error('Error.');
          }
        })
        .catch((err) => {
          // Handle error
          console.log(err);
          toast.error('Error');
        });
    }
  };

  const onChangeDocumentTwo = (e) => {
    e.preventDefault();
    if (e.target.files[0] && e.target.files[0].name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      setQuotationForm({ ...quotationForm, file2: null, file_2: '' });
      toast.error('Please select a valid file type.');
    } else {
      const file = e.target.files[0] || null;

      const formData = new FormData();
      formData.append('fileName', file);

      axios
        .post(process.env.REACT_APP_BASE_URL + '/mm/file', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'x-access-token': storedData.token,
          },
        })
        .then((resp) => {
          if (resp.status === 200) {
            // Handle success
            setQuotationForm({ ...quotationForm, file_2: resp.data });
          } else {
            // Handle other status codes if needed
            toast.error('Error.');
          }
        })
        .catch((err) => {
          // Handle error
          console.log(err);
          toast.error('Error');
        });
    }
  };

  const getQuotationRequest = async (limit = TABLE_DEFAULT_LIMIT, offset = 0) => {
    try {
      let condition = {
        vendorName: vendorName || '',
      };
      const quotationList = await getQuotationListRequest(offset, limit, params.id, condition);
      return {
        data: (quotationList && quotationList.data.rows) || [],
        totalRecords: (quotationList && quotationList.data && quotationList.data.count) || 0,
      };
    } catch (e) {
      console.error(e);
      return {
        errorMessage: e.message,
      };
    }
  };

  useEffect(() => {
    getMR();
  }, []);

  const getMR = async () => {
    const machineRequest = await getMachineRequest(params.id);
    setRequestDetail(machineRequest.data);
    const quotationsMachineRequest = await getQuotationRequest(TABLE_DEFAULT_LIMIT, currentPage - 1);
    setTotalRecords(quotationsMachineRequest.totalRecords);
    setQuotationList(quotationsMachineRequest.data);
  };

  async function getRequests() {
    const quotationsMachineRequest = await getQuotationRequest(TABLE_DEFAULT_LIMIT, currentPage - 1);
    setTotalRecords(quotationsMachineRequest.totalRecords);
    setQuotationList(quotationsMachineRequest.data);
  }
  useEffect(() => {
    getRequests();
  }, [currentPage, vendorName]);

  const editQuotationRequest = async (e, request) => {
    e.preventDefault();
    const getSingleQuotation = async () => {
      setQuotationForm(request);
    };
    getSingleQuotation();
    setShow(true);
  };

  const deleteFile = (field) => {
    try {
      destroy(`/mm/machine/filefrom/${params.id}/${field}`)
        .then((resp) => {
          setRequestDetail(resp.data);
          setDocumentShowConfirmModel(false);
        })
        .catch((error) => {
          toast.error(error.message);
        });
    } catch (e) {
      toast.error(e.message);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    if (quotationForm.id && quotationForm.id !== null) {
      try {
        setIsButtonDisabled(false);
        if (!quotationForm.vendorName) toast.error('Vendor Name must be provided');
        else if (!quotationForm.price) toast.error('Price must be provided');
        else if (!quotationForm.description) toast.error('Description By must be provided');
        else if (!quotationForm.file_1) toast.error('File must be provided');
        else {
          await editQuotation(quotationForm.id, quotationForm);
          toast.success('Quotation updated successfully');
          setShow(false);
          getRequests();
        }
      } catch (err) {
        toast.error(err?.response?.data?.data?.message || err?.message || 'Something went wrong', { autoClose: 2000 });
      }
    } else {
      if (isButtonDisabled) {
        return; // If button is disabled, return early
      }
      setIsButtonDisabled(true); // Disable the button
      try {
        quotationForm.requestUUID = await requestDetail.id;
        if (!quotationForm.vendorName) toast.error('Vendor Name must be provided');
        else if (!quotationForm.price) toast.error('Price must be provided');
        else if (!quotationForm.description) toast.error('Description By must be provided');
        else if (!quotationForm.file_1) toast.error('File By must be provided');
        else {
          await createQuotation(quotationForm);
          toast.success('Quotation added successfully');
          setShow(false);
          getRequests();
        }
      } catch (err) {
        toast.error(err?.response?.data?.data?.message || err?.message || 'Something went wrong', { autoClose: 2000 });
      } finally {
        // Enable the button after a delay of 3 seconds
        setTimeout(() => {
          setIsButtonDisabled(false);
        }, 500);
      }
    }
  };

  const handleRemove = (event, quotationId, requestId) => {
    event.preventDefault();
    const deleteQuotat = async () => {
      try {
        const data = await deleteQuotation(quotationId, requestId);
        toast.success(data.data);
        setShowConfirmModel(false);
        getRequests();
      } catch (err) {
        toast.error(err?.response?.data?.data?.message || 'Something went wrong', { autoClose: 2000 });
      }
    };
    deleteQuotat();
  };

  const handleDownloadThree = async (e) => {
    e.preventDefault();
    try {
      const requestOptions = {
        method: 'GET',
        headers: {
          'x-access-token': storedData.token,
        },
      };
      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/mm/machine/report/${requestDetail.id}`, requestOptions);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      clickToDownload.current.href = url;
      clickToDownload.current.setAttribute('download', requestDetail.model);
      setTimeout(() => {
        clickToDownload.current.click();
      }, 500);
    } catch (err) {
      console.error(err);
      toast.error(err.message);
    }
  };

  return (
    <React.Fragment>
      <ToastContainer />
      <nav className="" aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <Link to="/mm/machine-requests">Machine Request List</Link>
          </li>
          <li className="breadcrumb-item">
            <Link to={`/mm/machine-requests/${requestDetail.id}`}>Machine Request Detail</Link>
          </li>
        </ol>
      </nav>
      <div className="card">
        <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
          <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
            Machine Request Detail
          </h4>
          <a ref={clickToDownload} href="" target="_blank" className="hiddenItem">
            HiddenClick
          </a>
          {requestDetail.status ? (
            <button type="button" onClick={(e) => handleDownloadThree(e)} className="btn app-btn-default dark-color">
              Download Report
            </button>
          ) : (
            ''
          )}
        </div>
        <div className="card-body">
          <Row className="top-row">
            <div className="col-md-2">
              <dd className="display-title mb-1">Machine Name</dd>
              <dt className="display-value">{requestDetail.model}</dt>
            </div>
            <div className="col-md-2">
              <dd className="display-title mb-1">Status</dd>
              <dt className="display-value">{requestDetail.status}</dt>
            </div>
            <div className="col-md-2">
              <dd className="display-title mb-1">Requested Date</dd>
              <dt className="display-value">{formatDate(requestDetail.requestedDate)}</dt>
            </div>
            <div className="col-md-2">
              <dd className="display-title mb-1">Requested By</dd>
              <dt className="display-value">{requestDetail.requestedBy}</dt>
            </div>
            <div className="col-md-2">
              <dd className="display-title mb-1">Initiated By</dd>
              <dt className="display-value">{requestDetail.initiatedBy}</dt>
            </div>
          </Row>
          <Row className="top-row">
            <div className="col-md-2">
              <dd className="display-title mb-1">Reason</dd>
              <dt className="display-value">{requestDetail.reason}</dt>
            </div>
            <div className="col-md-2">
              <dd className="display-title mb-1">Factory</dd>
              <dt className="display-value">{requestDetail?.factory?.name}</dt>
            </div>
          </Row>
          <Row>
            {(requestDetail.file1 || requestDetail.file2) && (
              <Col xs={4}>
                <h6>Downloads</h6>
                <ul className="list-group">
                  {requestDetail.file1 && (
                    <li className="list-group-item">
                      <Row>
                        <Col xs={8} className="file-name">
                          {requestDetail.file1}
                        </Col>
                        <Col xs={4} className="text-end actions">
                          <a href={`${process.env.REACT_APP_BASE_URL}/file/download?filePath=${requestDetail.file1}`}>
                            <DownloadIcon />
                          </a>
                          <DeleteIcon
                            onClick={(e) => handleShowDocumentConfirmModal(e, 'file1')}
                            style={{ color: 'rgb(220, 53, 69)', cursor: 'pointer' }}
                          />
                        </Col>
                      </Row>
                    </li>
                  )}
                  {requestDetail.file2 && (
                    <li className="list-group-item">
                      <Row>
                        <Col xs={8} className="file-name">
                          {requestDetail.file2}
                        </Col>
                        <Col xs={4} className="text-end actions">
                          <a href={`${process.env.REACT_APP_BASE_URL}/file/download?filePath=${requestDetail.file2}`}>
                            <DownloadIcon />
                          </a>
                          <DeleteIcon
                            onClick={(e) => handleShowDocumentConfirmModal(e, 'file2')}
                            style={{ color: 'rgb(220, 53, 69)', cursor: 'pointer' }}
                          />
                        </Col>
                      </Row>
                    </li>
                  )}
                </ul>
              </Col>
            )}
          </Row>
        </div>
      </div>
      {requestDetail.status ? (
        <>
          <div className="row mb-2">
            <div className="form-group col-md-4 col-lg-4">
              <input
                type="text"
                className="form-control mt-5"
                id="exampleInputEmail1"
                placeholder="Please enter vendor Name"
                aria-describedby="emailHelp"
                value={vendorName}
                onChange={(e) => {
                  setVendorName(e.target.value);
                }}
              />
            </div>
            <div className="form-group col-md-8 col-lg-8">
              <div className="btn-wrapper justify-content-start">
                <button
                  type="button"
                  className="btn app-btn-default mt-5"
                  onClick={(e) => {
                    setVendorName('');
                  }}
                >
                  Reset
                </button>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
              <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
                Quotations | {totalRecords ?? 0}
              </h4>
              <button type="button" className="btn app-btn-default dark-color" onClick={handleShow}>
                Add Quotation
              </button>
            </div>
            {totalRecords !== 0 ? (
              <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
                <div className="row">
                  <div className="col">
                    <Table responsive striped>
                      <thead>
                        <tr>
                          <th>Vendor Name</th>
                          <th>Price</th>
                          <th>Description</th>
                          <th>Status</th>
                          <th>Created Date</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {quotationList?.map((request, index) => {
                          return (
                            <tr key={request.id} className={request.isDeleted == true ? 'disabled-tr' : ''}>
                              <td>{request.vendorName}</td>
                              <td>{request.price}</td>
                              <td>{request.description}</td>
                              <td>{request.status}</td>
                              <td>{formatDate(request.createdAt)}</td>
                              <td className="actions">
                                <Link to={`/mm/machine-requests/${params.id}/quotations/${request.id}`}>
                                  <ViewIcon />
                                </Link>
                                &nbsp;&nbsp;
                                <span style={{ cursor: 'pointer' }} onClick={(event) => editQuotationRequest(event, request)}>
                                  <EditIcon />
                                </span>
                                &nbsp;&nbsp;
                                <Link onClick={(e) => handleShowConfirmModal(e, request.uuid, requestDetail.id)} to="/">
                                  <DeleteIcon />
                                </Link>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                    <PaginationInPage
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                      totalRecords={totalRecords}
                      TABLE_DEFAULT_LIMIT={TABLE_DEFAULT_LIMIT}
                    />
                  </div>
                </div>
              </div>
            ) : (
              <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
                <h4 className="card-title mb-0" style={{ fontSize: '16px', color: 'red' }}>
                  No Data Available
                </h4>
              </div>
            )}
          </div>
        </>
      ) : (
        ''
      )}
      <Modal size="lg" show={show} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header>
          <Modal.Title>{!Object.keys(quotationForm).includes('id') ? 'Add Quotation' : 'Edit Quotation'}</Modal.Title>
          <button type="button" className="btn-close" aria-label="Close" onClick={handleClose}></button>
        </Modal.Header>
        <Modal.Body>
          <Form noValidate validated={validated}>
            <Row>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Vendor Name" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={quotationForm.vendorName}
                    className="input"
                    name="vendorName"
                    type="text"
                    placeholder="name@example.com"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Price" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={quotationForm.price}
                    className="input"
                    name="price"
                    type="number"
                    placeholder="name@example.com"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Description" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={quotationForm.description}
                    className="input"
                    name="description"
                    type="text"
                    placeholder="name@example.com"
                    required
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row>
              <Col xs={4} className="requested-date">
                <FloatingLabel controlId="floatingInput" label="GST" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={quotationForm.gst}
                    className="input"
                    name="gst"
                    type="text"
                    placeholder="name@example.com"
                    // required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Contact Number" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={quotationForm.contactNumber}
                    className="input"
                    name="contactNumber"
                    type="number"
                    placeholder="name@example.com"
                    // required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Email" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={quotationForm.email}
                    className="input"
                    name="email"
                    type="text"
                    placeholder="name@example.com"
                    // required
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col xs={4} className="requested-date">
                <FloatingLabel controlId="floatingInput" label="Contact Person" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={quotationForm.contactPerson}
                    className="input"
                    name="contactPerson"
                    type="text"
                    placeholder="name@example.com"
                    // required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Address" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={quotationForm.address}
                    className="input"
                    name="address"
                    type="text"
                    placeholder="name@example.com"
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row className="bottom-content">
              <Col xs={12}>
                <Alert.Heading>Quotation Documents</Alert.Heading>
                <hr />
              </Col>
              <Col xs={6}>
                <Form.Group controlId="formFile" className="mb-3">
                  <Form.Label>Document 1</Form.Label>
                  <Form.Control onChange={onChangeDocumentOne} type="file" name="file_1" aria-required="false" required />
                  {quotationForm.file_1 !== null ? <p className="mb-0">{quotationForm.file_1}</p> : ''}
                </Form.Group>
              </Col>
              <Col xs={6}>
                <Form.Group controlId="formFile" className="mb-3">
                  <Form.Label>Document 2</Form.Label>
                  <Form.Control onChange={onChangeDocumentTwo} type="file" name="file_2" aria-required="false" />
                  {quotationForm.file_2 !== null ? <p className="mb-0">{quotationForm.file_2}</p> : ''}
                </Form.Group>
              </Col>
            </Row>
            <Button onClick={handleSubmit} type="submit" className="add-request-btn mt-4 mb-3" disabled={isButtonDisabled}>
              {!Object.keys(quotationForm).includes('id') ? 'Add Quotation' : 'Update Quotation'}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
      <Modal size="sm" show={documentShowConfirmModel} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header className="bg-danger text-light py-2">
          <Modal.Title>Delete Document</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex justify-content-start">
            <img src={AlertIcon} />
            <p className="ps-3 mb-0">Are you sure? Action cannot be undone.</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="btn-wrapper">
            <button onClick={handleCloseDocumentConfirmModal} className="btn app-btn-default btn-sm">
              Cancel
            </button>
            <button onClick={() => deleteFile(fieldToDeleted)} className="btn app-btn-danger btn-sm">
              Delete
            </button>
          </div>
        </Modal.Footer>
      </Modal>
      <Modal size="sm" show={showConfirmModel} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header className="bg-danger text-light py-2">
          <Modal.Title>Quotation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex justify-content-start">
            <img src={AlertIcon} alt="Alert" />
            <p className="ps-3 mb-0">Are you sure? Action cannot be undone.</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="btn-wrapper">
            <button onClick={handleCloseConfirmModal} className="btn app-btn-default btn-sm">
              Cancel
            </button>
            <button onClick={(event) => handleRemove(event, quotationIdToDeleted, machineToDeleted)} className="btn app-btn-danger btn-sm">
              Delete
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default MachineRequestDetails;
